module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#pause",
      toString: function () {
        return this.url;
      }
    }